module.exports = __webpack_public_path__ + "static/media/integrate.b016c773.svg";